import axios from "axios";

const getBase = () => "timetables"
const subBase = () => "timeTableItems"


const timeTable = {
    deleteTimetable: (id) => {
        return axios.delete(getBase() + '/' + id);
    }, 

    getTimetablebyId: (id) => {
        return axios.get(getBase() + id);
    }, 

    getTimetablebySemester: (programmeId, semester, levelId, page, size) => {
        return axios.get(getBase() + "?semesterId=" + semester + "&programmeId=" + programmeId + "&levelId=" + levelId + "&page=" + page + "&size=" + size);
    }, 

    getTimetableForStudent: async (studentId, semesterId) => {
        return axios.get(getBase() + "/students?studentId=" + studentId + "&semesterId=" + semesterId);
    },

    getTimetablebyTypes: () => {
        return axios.get(getBase() + "/timeTableTypes");
    },

    getTimetablebyStatus: () => {
        return axios.get(getBase() + "/timeTableStatuses");
    },

    getTimebyDays: () => {
        return axios.get(getBase() + "/days");
    },

    getTimebyTypes: () => {
        return axios.get(getBase() + "/timeTableTypes");
    },

    getTimebyStatus: (id) => {
        return axios.patch(getBase() + '/' + id + "/status");
    },
        
    createTimetable: (data) => {
        return axios.post(getBase(), data);
    },

    updateTimetable: (id, data) => {
        return axios.put(getBase() + '/' + id, data);
    },

    deleteTimetableItem: (id) => {
        return axios.delete(getBase() + id);
    },

    getTimetableItem: (id) => {
        return axios.get(getBase() + id);
    },

    getTimetableiItembyId: (timeTableId) => {
        return axios.get(getBase() + timeTableId);
    },

    createTimetableItem: (data) => {
        return axios.post(subBase(), data);
    },

    updateTimetableItem: (id, data) => {
        return axios.put(subBase() + '/' + id, data);
    },

    getTimeTableItems: (timeTableId) => {
        return axios.get(subBase() + '/byTimeTable/' + timeTableId);
    },

    deleteTimetableitem: (id) => {
        return axios.delete(subBase() + '/' + id);
    },

    updateStatus: (id, status) => {
        return axios.patch(getBase() + '/' + id + "/status?status="+status, { status });
    },

    // deleteTimetableiItem: (id) => {
    //     return axios.delete(getBase() + id);
    // }
}; 


export default timeTable; 